/**
 * regenerarPagare — regenera el pagaré de una solicitud FIRMADA llamando al
 * generador server-side ÚNICO (edge function `generar-pagare`, pdf-lib).
 *
 * ANTES esto armaba el PDF en el navegador con html2pdf.js (html2canvas), que
 * salía corrido/cortado y pisaba el pagaré bueno de la app. Pasó 5 veces en
 * producción. AHORA delega en el mismo generador determinístico que usa la app:
 * mismo documento, sin render de navegador. El servidor lee la firma de la DB,
 * arma el PDF, lo sube al bucket 'pagares' y setea pagare_pdf_url.
 */
import { supabase } from './supabase'

export async function regenerarPagare(
  solicitudId: string,
): Promise<{ ok: true; url: string } | { ok: false; error: string }> {
  try {
    const { data, error } = await supabase.functions.invoke('generar-pagare', {
      body: { solicitud_id: solicitudId },
    })
    if (error) return { ok: false, error: error.message ?? 'No se pudo generar el pagaré.' }
    if (!data?.ok) {
      return { ok: false, error: (data && (data.error as string)) || 'El servidor no pudo generar el pagaré.' }
    }
    return { ok: true, url: (data.url as string) ?? '' }
  } catch (e) {
    return { ok: false, error: e instanceof Error ? e.message : 'Error al regenerar el pagaré' }
  }
}
